import dispatcher from '../../dispatcher';
import scrollStore from '../../scroll/scroll.store';
import colorStore from '../../color/color.store';
import simpleVertexShader from '../../../modules/stage/glsl/simple.vertex.glsl';
import postFragmentShader from '../../../modules/stage/glsl/post.fragment.glsl';
import * as utils from '../../utils';
// import resizeStore from '../../resize/resize.store';
// import bpStore from '../../resize/breakpoint.store';
// import simpleFragmentShader from '../../../modules/stage/glsl/simple.fragment.glsl';
// import * as calcProperty from '/src/assets/scripts/modules/utils/calcProperty';
// import * as THREE from '/src/assets/scripts/libs/three-r97/three.module';
// import TweenMax from '../../../libs/TweenMax';
import TweenMax from 'gsap/all';

var THREE, calcProperty;
var name = 'main-post';

var Decorator = function(component, options) {
	this._component = component;
	this._options = {}
	this._composer = component._composer;
	this._hoverIndex = 0;
	this._maxHover = 4;
	this._hovers = [];
	this._hoverMasks = [];

	this.init = function() {
		var size = this._component._renderer.getSize(new THREE.Vector2());
		var ww = size.width;
		var wh = size.height;

		this._postData = this._composer.shaderPass({
			vertexShader: simpleVertexShader,
			fragmentShader: postFragmentShader,
			uniforms: {
				c1: {type: 'v3', value: [0, 0, 0]},
				c2: {type: 'v3', value: [0, 0, 0]},
				gradientLeft: {type: 'f', value: 0},
				gradientRight: {type: 'f', value: 0},
				distortionLeft: {type: 'f', value: 0},
				distortionRight: {type: 'f', value: 0},
				resolution: {type: 'v2', value: [ww, wh]},
				gradientShift: {type: 'f', value: 0},
				hovers : {type: 'm4', value: new THREE.Matrix4()
						.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0)
				},
				hoverMasks : {type: 'm4', value: new THREE.Matrix4()
						.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0)
				}
			}
		});

		this._mesh = this._postData.mesh;
		this._uniforms = this._mesh.material.uniforms;

		this._mesh.material.transparent = true;
		this._mesh.material.blending = THREE.NormalBlending;
		this._mesh.material.needsUpdate = true;

	}.bind(this);

	this.loop = function() {
		var gradient = colorStore.getData().mixGradient;
		var uniforms = this._uniforms;
		var changed = false;

		if (this._component._destruct) return;

		uniforms.c1.value = [gradient[0].x, gradient[0].y, gradient[0].z];
		uniforms.c2.value = [gradient[1].x, gradient[1].y, gradient[1].z];

		if (!this._previousGradient) {
			changed = true;
		} else {
			if (this._previousGradient[0].x !== gradient[0].x ||
				this._previousGradient[0].y !== gradient[0].y ||
				this._previousGradient[0].z !== gradient[0].z ||
				this._previousGradient[1].x !== gradient[1].x ||
				this._previousGradient[1].y !== gradient[1].y ||
				this._previousGradient[1].z !== gradient[1].z) {
				changed = true;
			}
		}

		this._previousGradient = [
			gradient[0].clone(),
			gradient[1].clone()
		]

		if (changed) {
			this._composer.needsUpdate = true;
		}
	}.bind(this);

	this.handleDispatcher = function(e) {
		var uniforms = this._uniforms;
		var self = this;

		if (e.type === 'gradient:lock') {
			this._gradientLocked = true;
		}
		if (e.type === 'gradient:unlock') {
			this._gradientLocked = false;
		}
		if (e.type === 'distortion:lock') {
			this._distortionLocked = true;
		}
		if (e.type === 'distortion:unlock') {
			this._distortionLocked = false;
		}

		if (e.type === 'gradient:show') {
			if (this._gradientLocked ||
				this._gradientVisible) {
				return;
			}
			this._gradientVisible = true;

			TweenMax.killTweensOf(uniforms.gradientRight);
			TweenMax.killTweensOf(uniforms.gradientLeft);
			TweenMax.set(uniforms.gradientRight, {
				value: 0
			});
			TweenMax.set(uniforms.gradientLeft, {
				value: 0
			});
			TweenMax.to(uniforms.gradientRight, 0.65, {
				value: 1,
				ease: window._easings.ease2,
				onUpdate: function() {
					self._composer.needsUpdate = true;
				}
			});
		}
		if (e.type === 'gradient:hide') {
			if (this._gradientLocked ||
				!this._gradientVisible) {
				return;
			}
			this._gradientVisible = false;

			TweenMax.killTweensOf(uniforms.gradientRight);
			TweenMax.killTweensOf(uniforms.gradientLeft);
			TweenMax.set(uniforms.gradientRight, {
				value: 1
			});
			TweenMax.set(uniforms.gradientLeft, {
				value: 0
			});
			TweenMax.to(uniforms.gradientLeft, 0.8, {
				value: 1,
				ease: window._easings.ease2,
				onUpdate: function() {
					self._composer.needsUpdate = true;
				}
			});
		}
		if (e.type === 'gradient:shift') {
			TweenMax.to(uniforms.gradientShift, e.speed || 0.8, {
				value: '+=1',
				ease: Power2.easeInOut,
				onUpdate: function() {
					self._composer.needsUpdate = true;
				}
			});
		}
		if (e.type === 'distortion:reset') {
			TweenMax.set(uniforms.distortionRight, {
				value: 0
			});
			TweenMax.set(uniforms.distortionLeft, {
				value: 0
			});
			this._composer.needsUpdate = true;
		}
		if (e.type === 'distortion:show') {
			if (this._distortionLocked || this._distortionVisible) return;
			this._distortionVisible = true;

			TweenMax.killTweensOf(uniforms.distortionRight);
			TweenMax.killTweensOf(uniforms.distortionLeft);
			TweenMax.set(uniforms.distortionRight, {
				value: 0
			});
			TweenMax.set(uniforms.distortionLeft, {
				value: 0
			});
			TweenMax.to(uniforms.distortionRight, 1.2, {
				value: 1,
				delay: 0.1,
				ease: window._easings.ease2,
				onUpdate: function() {
					self._composer.needsUpdate = true;
				}
			});
		}
		if (e.type === 'distortion:hide') {
			if (this._distortionLocked || !this._distortionVisible) return;
			this._distortionVisible = false;

			TweenMax.killTweensOf(uniforms.distortionRight);
			TweenMax.killTweensOf(uniforms.distortionLeft);
			TweenMax.set(uniforms.distortionRight, {
				value: 1
			});
			TweenMax.set(uniforms.distortionLeft, {
				value: 0
			});
			TweenMax.to(uniforms.distortionLeft, 1.5, {
				value: 1,
				ease: window._easings.ease2,
				onUpdate: function() {
					self._composer.needsUpdate = true;
				}
			});
		}

		if (e.type === 'gradient:hover') {
			if (Modernizr.touchevents) return;

			this._hoverIndex++;
			this._hoverIndex %= this._maxHover;

			this.hover({
				index: this._hoverIndex,
				position: {
					x: e.x,
					y: e.y
				},
				direction: e.direction,
				speed: e.speed,
				element: e.element
			});
		}
	}.bind(this);

	this.hover = function(options) {
		var index = options.index;
		var position = options.position;
		var direction = options.direction || [0, 0];
		var speed = options.speed || 0;
		var element = options.element;
		var uniforms = this._uniforms;
		var mask, maskOffset;
		var scrolled = scrollStore.getData().top;
		var transformX, transformY;
		var found = false;
		var self = this;

		// prevent multiple hovers
		this._hovers.forEach(function(hover) {
			if (hover.element === element &&
				Date.now() - hover.startTime < 800) {
				found = true;
			}
		});
		if (found) return;

		calcProperty.attach(element, {
			namespace: 'main-post'
		});

		element._calcProperty.subscribeGlobal(self.handleScroll);

		this._hovers[index] = {
			x: position.x,
			y: position.y,
			scrolled: scrollStore.getData().top,
			element: element,
			startTime: Date.now(),
			tween: null,
			direction: direction,
			speed: speed
		}

		maskOffset = utils.offset(element);
		transformX = element._calcProperty.getGlobal({
			property: 'x'
		});
		transformY = element._calcProperty.getGlobal({
			property: 'y'
		});

		mask = {
			l: maskOffset.left,
			t: maskOffset.top,
			w: element.clientWidth,
			h: element.clientHeight,
			scrolled: scrolled,
			transformX: transformX,
			transformY: transformY,
			element: element
		}

		this._hoverMasks[index] = mask;

		uniforms.hovers.value.elements[index * 4] = position.x;
		uniforms.hovers.value.elements[index * 4 + 1] = position.y;

		uniforms.hoverMasks.value.elements[index * 4] = mask.l + transformX;
		uniforms.hoverMasks.value.elements[index * 4 + 1] = mask.t - scrolled + transformY;
		uniforms.hoverMasks.value.elements[index * 4 + 2] = mask.w;
		uniforms.hoverMasks.value.elements[index * 4 + 3] = mask.h;

		this._composer.needsUpdate = true;

		if (this._hovers[index].tween) {
			this._hovers[index].tween.kill();
		}

		speed = speed / 3;

		this._hovers[index].tween =
			TweenMax.to({r: 0, o: 1}, 1.5, {
				r: 1,
				o: 0,
				ease: Power2.easeOut,
				onUpdate: function() {
					speed = speed / 1.03;
					if (!isNaN(direction[0] * speed) &&
						!isNaN(direction[1] * speed)) {
						uniforms.hovers.value.elements[index * 4] += direction[0] * speed;
						uniforms.hovers.value.elements[index * 4 + 1] += direction[1] * speed;
					}

					uniforms.hovers.value
						.elements[index * 4 + 2] = this._targets[0].r;
					uniforms.hovers.value
						.elements[index * 4 + 3] = this._targets[0].o;
					self._composer.needsUpdate = true;
				}
			});
	}.bind(this);

	this.handleScroll = function() {
		var uniforms = this._uniforms;
		var self = this;
		var scrolled = scrollStore.getData().top;

		this._hovers.forEach(function(hover, index) {
			var delta;
			if (hover.scrolled === scrolled) return;

			delta = scrolled - hover.scrolled;
			hover.scrolled = scrolled;
			hover.y = hover.y - delta;

			uniforms.hovers.value.elements[index * 4 + 1] = hover.y;
		});

		this._hoverMasks.forEach(function(mask, index) {
			var delta;
			var element = mask.element;

			var transformX = element._calcProperty.getGlobal({
				property: 'x'
			});
			var transformY = element._calcProperty.getGlobal({
				property: 'y'
			});

			if (mask.scrolled !== scrolled ||
				mask.transformX !== transformX ||
				mask.transformY !== transformY) {

				mask.scrolled = scrolled;
				mask.transformX = transformX;
				mask.transformY = transformY;

				uniforms.hoverMasks.value.elements[index * 4] = mask.l + transformX;
				uniforms.hoverMasks.value.elements[index * 4 + 1] = mask.t - scrolled + transformY;
			}

		});
	}.bind(this);
}

var attach = function(component, options) {
	var decorator;

	if (!component._decorators) {
		component._decorators = {};
	}
	if (!component._decorators[name]) {
		component._decorators[name] = new Decorator(component, options);
	}
	decorator = component._decorators[name];

	Promise
	.all([
		import(/* webpackPrefetch: true */ '/src/assets/scripts/libs/three-r97/three.module'),
		import(/* webpackPrefetch: true */ '/src/assets/scripts/modules/utils/calcProperty'),
	]).then(([three, calc]) => {
		THREE = three;
		calcProperty = calc;

		decorator.init();

		component._loopFunctions.push(decorator.loop);
		dispatcher.subscribe(decorator.handleDispatcher);
		scrollStore.subscribe(decorator.handleScroll);
	});

	return decorator;
}

var detach = function(component, options) {
	var decorator = component._decorators[name];

	dispatcher.unsubscribe(decorator.handleDispatcher);
	scrollStore.unsubscribe(decorator.handleScroll);
}

export default {
	attach: attach,
	detach: detach
};